import { ButtonBlock, ButtonBlockProps } from '@jbhi-fi/components/src/ButtonBlock/ButtonBlock';
import React from 'react';
import { useCustomerApi } from '../../../customers/hooks/customerApi';

export const PerksButtonBlock = ({ buttons, alignment }: ButtonBlockProps) => {
  const { customer } = useCustomerApi();
  const isPerks = window.Jbhifi.customerDetails?.isPerks;

  const displayAvailableButtons = () => {
    let filteredButtons = buttons;
    if (customer?.id) {
      filteredButtons = buttons
        ?.filter(button => button.name === 'Join JB Perks')
        ?.map(button => ({ ...button, type: 'primary' }));
      if (isPerks) {
        filteredButtons = buttons?.filter(
          button => button.name !== 'Log into JB Perks' && button.name !== 'Join JB Perks'
        );
      }
    }
    return filteredButtons;
  };

  return <ButtonBlock buttons={displayAvailableButtons()} alignment={alignment} />;
};
